import { PropsWithChildren, createContext } from 'react'
import { useParams } from 'react-router'
import { getHotelDevices } from '../apis/hotelApis'
import { useQuery } from '@tanstack/react-query'
import { IDeviceInfo } from '../types/device'

export interface IDeviceContext {
  hotelDevices: IDeviceInfo[]
}

export const DeviceContext = createContext<IDeviceContext>(null)

export const DeviceContextProvider = ({ children }: PropsWithChildren) => {
  const { hotelId } = useParams()

  const { data: devices } = useQuery({
    queryKey: [`/api/hotels/${hotelId}/devices`],
    queryFn: () => getHotelDevices(hotelId),
    enabled: !!hotelId,
  })

  return (
    <DeviceContext.Provider
      value={{
        hotelDevices: devices || [],
      }}>
      {children}
    </DeviceContext.Provider>
  )
}
